import { trackOnboardingCompleted, trackOnboardingStepSubmitted } from "@/utils/mixpanel";

export const setMixpanelOnboardingEvent = ({
  type,
  stepPath,
}: {
  type: "submit" | "completed";
  stepPath?: string;
}) => {
  if (type === "completed") {
    trackOnboardingCompleted();
    return;
  }

  if (stepPath) {
    trackOnboardingStepSubmitted(stepPath);
  }
};
